module.exports = __webpack_public_path__ + "img/img_rank_04.f540eaff.svg";